import { Handle, Position } from "reactflow"
import { CustomNodeProperties } from "../types/types"

import { Badge, Tooltip, Typography } from "@mui/material"

const NodoEtapa = (props: CustomNodeProperties) => {
    const { cantMensajes, descEstado } = props.data

    const nodo = (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
            }}
        >
            <Typography style={{ fontSize: '12px', textAlign: 'center', lineHeight: 1.2, padding: '0 4px' }}>
                {props.data.label}
            </Typography>
        </div>
    )

    return (
        <>
            <Handle type='target' position={Position.Left} />
            <Badge
                badgeContent={cantMensajes ?? 0}
                color='primary'
                max={999}
                sx={{
                    width: '100%',
                    height: '100%',
                    '& .MuiBadge-badge': {
                        top: -4,
                        right: -4,
                        fontSize: '0.65rem',
                        minWidth: 18,
                        height: 18,
                    }
                }}
                invisible={!cantMensajes}
            >
                {descEstado ? (
                    <Tooltip title={descEstado} arrow placement='top'>
                        {nodo}
                    </Tooltip>
                ) : nodo}
            </Badge>
            <Handle type='source' position={Position.Right} />
        </>
    )
}

export default NodoEtapa
